import React, {memo} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {Handle, Position} from 'reactflow'

export default memo(({data, isConnectable}: any) => {
  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={isConnectable}
        id='sendMessage1'
      />
      <div className='trigger-container'>
        <div className='trigger-box'>
          <img src='/media/svg/automation/messages.svg' alt='icon' />
          <div className='trigger-data'>
            <div className='title'>Send message #1</div>
            <div className='desc'>
              <OverlayTrigger
                placement='top'
                overlay={
                  <Tooltip>
                    Welcome, thank you for signing up to our list! Here is a 10% OFF code, see our
                    store on the link go.site/siwu
                  </Tooltip>
                }
              >
                <div>
                  Welcome, thank you for signing up to our list! Here is a 10% OFF code, see our
                  store on the link go.site/siwu
                </div>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      </div>
      {!data?.isDisableBottomHandler ? (
        <Handle
          type='source'
          position={Position.Bottom}
          onConnect={(params) => console.log('handle onConnect', params)}
          isConnectable={isConnectable}
          id='sendMessage2'
        />
      ) : null}
    </>
  )
})
